import { CancelButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import { FaturamentoModais } from '..';
import FaturamentoVisualizar from './FaturamentoVisualizar';

const Content = ({ pendencias }) => {
  return <FaturamentoVisualizar pendencias={pendencias} />;
};

const FaturamentoModal = () => {
  const [modalPendenciasFaturamento, setModalPendenciasFaturamento] = useContext(
    GlobalContext
  ).modalPendenciasFaturamento;
  const [pendencias] = useContext(GlobalContext).pendencias;

  const handleCloseModal = () => {
    setModalPendenciasFaturamento(false);
  };

  return (
    <SimpleDialog
      open={modalPendenciasFaturamento === FaturamentoModais.modalPendenciasFaturamento}
      onClose={handleCloseModal}
    >
      <SimpleDialogContent
        header={{
          title: 'Pendências para faturar',
          toolbar: <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>,
        }}
        content={<Content pendencias={pendencias} />}
      />
    </SimpleDialog>
  );
};

export default FaturamentoModal;
